import { QuoteDetailsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const QuoteDetailsPage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { data, error, loading } = useQuery(QuoteDetailsPageDocument, {
    variables: {
      companyId,
    },
  })
  const hasQuickQuoteBuilderFeature = !!data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_quick_quote_builder'
  )?.enabled

  return (
    <ResponsivePage.Body
      showHeader={false}
      variant="full"
      authorized={hasQuickQuoteBuilderFeature}
      loading={loading}
      error={error}
    >
      Quote details
    </ResponsivePage.Body>
  )
}

export default QuoteDetailsPage
